const mEditionMapCard = {
  mEditionMapCard: {
    alerts: {
      updateProyecto: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Los datos del mapa fueron editados exitosamente.'
      }
    },

    buttonPrimary: 'GUARDAR',

    inputs: {
      activacion: {
        label: 'Fecha de Activación',
        labelOne: 'Con Fecha de Inicio',
        labelZero: 'De Forma Inmediata',
        tooltipOne: 'La activación de cada camino y paso se realizará tomando en cuenta el día de entrega + la fecha de inicio del mapa',
        tooltipZero: 'La activación de cada camino y paso se realizará tomando en cuenta la fecha de inscripción del alumno + el día de mapa.'
      },

      descripcion: {
        label: 'Descripción del Mapa',
        message: '* De 10 a 120 caracteres',
        placeholder: 'Escribe aquí una descripción'
      },

      fecha_fin: {
        label: 'Fecha de Finalización',
        message: '* Dato opcional',
        placeholder: 'DD MM, AAAA'
      },

      fecha_inicio: {
        label: 'Fecha de Inicio',
        message: '* Dato requerido',
        placeholder: 'DD MM, AAAA'
      },

      publicado: {
        label: 'Estado de Publicación',
        textFalse: 'Borrador',
        textTrue: 'Publicado'
      }
    },

    validation: {
      descripcion: {
        maxLength: 'La longitud permitida es de 10 a 120 caracteres.',
        minLength: 'La longitud permitida es de 10 a 120 caracteres.',
        required: 'Descripción es requerida.'
      },

      fecha_inicio: {
        required: 'Fecha de inicio es requerida.'
      }
    }
  }
}

export default mEditionMapCard
